import EditIcon from '@mui/icons-material/Edit';
import { Button } from 'devextreme-react';

type EditButtonProps = {
    handleClick: () => void;
}

const EditButton = (props: EditButtonProps) => {
    return <Button
        data-testid="btnEdit"
        stylingMode="outlined"
        onClick={props.handleClick}
    >
        <EditIcon sx={{ fontSize: 15 }} />
    </Button>
}

export default EditButton;